import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_ROLES || '/role-management/roles', {
      queryParams: {
        service: 'rapidoo-admin'
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Impossible de charger les rôles',
        data: null,
      }
    }

    const data = Array.isArray(raw.data) ? raw.data : []

    let formatted = data.map(el => ({
      name: el.name,
      id: el.id,
      permissions: el.permissions || [],
      updatedAt: el.updatedAt,
    }))

    let finalData = formatted
    // === Recherche textuelle locale ===
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()
    if (searchTerm) {
      finalData = finalData.filter(el => {
        return Object.values(el).some(val => 
          val && typeof val !== 'object' && String(val).toLowerCase().includes(searchTerm)
        )
      })
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      finalData = [...finalData].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = finalData.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: finalData.length,
        result: paginated,
      },
    }
  },
}
